var foundEarnSection = false;
var earnItems = document.querySelectorAll('.how-to-earn-subtitle');
document.addEventListener("DOMContentLoaded", () => {
    setInterval(() => {
        if( foundEarnSection == false ){
            if( earnItems.length != 0 ){
                updateRewardsEarnSection(earnItems);
                updateFlexDirection();

                foundEarnSection = true;
            }
        }
    }, 1000);

    var redeemBottomNote = document.querySelector('.redeem-bottom-note');

    if (redeemBottomNote) {
        var policiesBlock = redeemBottomNote.closest('.bg-policies-block');
        if (policiesBlock) {
            policiesBlock.appendChild(redeemBottomNote);
        }
    }
});

window.addEventListener('resize', updateRewardsEarnSection(earnItems));
window.addEventListener('resize', updateFlexDirection);

function updateRewardsEarnSection(elements) {

    elements.forEach(function(element) {
        var haloRow = element.closest('.halo-row');
        if (haloRow) {
            haloRow.classList.add('rewards-earn-sec');

            if (window.innerWidth > 767) {
                haloRow.classList.remove('column-6');
                haloRow.classList.add('column-3');
            }
        }
    });
}

function updateFlexDirection() {
    var elements = document.querySelectorAll('.press-banner-block-wrapper');

    elements.forEach(function(element) {
        if (window.innerWidth > 767) {
            element.style.flexDirection = 'row-reverse';
        } else {
            element.style.flexDirection = 'column-reverse';
        }
    });
}